import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {CarouselDots} from "./carousel-dots";
import {AppTerms} from "../../../app/app-terms";
import classNames from "classnames";
import styles from "../styles/carousel.module.scss"

export class CarouselFooterProps extends BaseProps {
  count: Number;
  selectedDotIndex: Number;
  onClick: Function;
  i18n: AppTerms;
}

export const CarouselFooter = (props: CarouselFooterProps) => {
  const onClick = (index) => props.onClick(index);
  return (
    <div className={classNames(styles.footer_container)}>
      <CarouselDots
        onClick={onClick}
        count={props.count}
        selectedDotIndex={props.selectedDotIndex}
      />
    </div>
  )
};
